export type ProgressKey =
  | 'SERVICES_LIST_PAGE'
  | 'SERVICES_CONFIRMATION_PAGE'
  | 'SERVICES_THANK_YOU_PAGE';

export interface ProgressEntity {
  key: ProgressKey;
  level: number;
}

export const servicesProgressEntities: ProgressEntity[] = [
  {
    key: 'SERVICES_LIST_PAGE',
    level: 1,
  },
  {
    key: 'SERVICES_CONFIRMATION_PAGE',
    level: 2,
  },
  {
    key: 'SERVICES_THANK_YOU_PAGE',
    level: 3,
  },
];
